import { render, staticRenderFns } from "./DigitalReferenceFormPage.vue?vue&type=template&id=223c8817&scoped=true"
import script from "./DigitalReferenceFormPage.vue?vue&type=script&lang=ts"
export * from "./DigitalReferenceFormPage.vue?vue&type=script&lang=ts"
import style0 from "./DigitalReferenceFormPage.vue?vue&type=style&index=0&id=223c8817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c8817",
  null
  
)

export default component.exports